import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PublicRoute ({component: Component, authed,componentProps, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => !authed
                ? <Component {...componentProps}>
                    {props.children}
                </Component>
                : <Redirect to={{pathname: '/', state: {from: props.location}}} />}
        />
    )
}
export default PublicRoute;
